import { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'

export const Row = ({
  className,
  label,
  value,
}: {
  className?: string
  label: ReactNode
  value: ReactNode
}) => (
  <tr>
    <td
      className={twMerge(
        'px-2 text-xs text-neutral-500 whitespace-nowrap align-top',
        className,
      )}
    >
      {label}
    </td>
    <td
      className={twMerge(
        'px-2 text-xs text-neutral-900 w-full whitespace-normal break-normal',
        className,
      )}
    >
      {value}
    </td>
  </tr>
)
